import { cn } from '../../utils'
import {
    getColorClasses,
    getContainedClasses,
    getOutlinedClasses,
    getSizeClasses,
    getVariantClasses,
} from './Label.styles'
import { LabelProps } from './Label.types'

export const Label = ({
    text,
    color = 'primary',
    className,
    variant,
    htmlFor,
    size,
}: LabelProps) => {
    const classes = cn(
        getColorClasses(color),
        getContainedClasses(color),
        getOutlinedClasses(color),
        getVariantClasses(color, variant),
        getSizeClasses(size)
    )
    return (
        <label
            className={cn(className, classes)}
            color={color}
            htmlFor={htmlFor}
        >
            {text}
        </label>
    )
}
